<div class="container-fluid containerSuccess">
    <h4 class="text-muted text-center"><fa-icon [icon]="faCircleCheck" class="primary-color fa-2x"></fa-icon><br> {{ 'SUCCESS.LABEL1' | translate }} 
        {{status}}</h4>
    <div class="mb-3">
        <mat-card class="successCard">
            <mat-card-content>
                <div id="success">
                    <img class="w-100">
                </div>
                <div>
                    <p class="text-center text-dark  cardText"><br> {{ 'SUCCESS.LABEL2' | translate }} <br>{{serviceNumber}}</p>
                    <p class=" text-muted align-items-stretch textDescription muted-color"> {{ 'SUCCESS.LABEL3' | translate }} </p>
                    <p class="align-items-stretch textDescriptionBlack black-color"> {{ 'SUCCESS.LABEL4' | translate }} </p>
                    <p class="align-items-stretch textDescriptionBlack black-color"> {{ 'SUCCESS.LABEL5' | translate }} </p>
                </div>
                <div class="col-sm-12 col-md-12 ">
                    <div class="row">
                        <div class="col-3 col-lg-4"></div>
                        <div class="col-sm-12 col-md-6 col-lg-4">
                            <a href="../../../assets/themes/liverpool/files/Garantia_PIF.pdf" download="Garantia_PIF">
                                <button class="p-2 mt-3 buttonCustom w-100 primary-color" type="button" mat-stroked-button>
                                    <span style="margin-right: 15px;"><fa-icon [icon]="faDownload" class="fa-solid fa-download primary-color "></fa-icon></span> <span class="primary-color"> {{ 'SUCCESS.LABEL6' | translate }} </span>
                                </button>
                            </a>
                        </div>
                        <div class="col-3 col-lg-4"></div>
                    </div>
                </div>
            </mat-card-content>
        </mat-card>
    </div>
    <div class="row">
        <div class="d-sm-none d-md-block col-6 col-md-6 col-lg-9"></div>
        <div class="col-6 col-md-6 col-lg-3 d-none d-sm-none d-md-flex justify-content-end mt-4">
            <button class="w-100 p-1" type="button" (click)="stepOn()" mat-raised-button color="accent"> {{ 'SUCCESS.LABEL7' | translate }} </button>
        </div>
        <div class="d-block d-sm-block d-md-none w-100">
            <mat-card class="serviceCard my-3">
                <mat-card-content>
                    <button class="w-100 p-1" type="button" (click)="stepOn()" mat-raised-button color="accent"> {{ 'SUCCESS.LABEL7' | translate }} </button>
                </mat-card-content>
            </mat-card>
        </div>
    </div><br><br>
</div>